export default __webpack_public_path__ + "static/media/Electrophoresis_Box.7cca23aa.svg";